import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AddressState } from './types';

const initialState: AddressState = {};

const addressSlice = createSlice({
  name: 'address',
  initialState,
  reducers: {
    setAddress: (state, action: PayloadAction<number>) => {
      state.addressId = action.payload;
    },
    resetAddress: (state) => {
      state.addressId = undefined;
    },
  },
});

export const {
  actions: { setAddress, resetAddress },
  reducer: addressSliceReducer,
} = addressSlice;
